import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetStudentsFrequencyReportUseCaseInterface } from 'domain/usecases';

export class RemoteGetStudentsFrequencyReport
  implements GetStudentsFrequencyReportUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetStudentsFrequencyReportUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetStudentsFrequencyReportUseCaseInterface.Params,
  ): Promise<GetStudentsFrequencyReportUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, params);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
